import type { UserAttributes } from '../user';

export const coblerAttributes: UserAttributes = {
  creationDate: new Date().getTime(),
  numberOfDevices: 0,
  ageInDays: 0,
};
